import * as React from "react";
import { Outlet } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import LogoutMenu from "../../LogoutMenu";
import BottomNav from "./BottomNav";
import Sidebar from "./Sidebar";

const CHROME_STYLE_KEY = "appShellChromeStyle";

// Preferência de chrome (Sidebar/AppBar): "blue" (Azul-Empório, padrão) ou
// "white" (chrome branco antigo, opcional) — usuário escolhe no menu da
// conta (LogoutMenu). Estado mora aqui porque AppShell é o ancestral comum
// de Sidebar e LogoutMenu.
const getStoredChromeStyle = () => {
  try {
    return localStorage.getItem(CHROME_STYLE_KEY) === "white" ? "white" : "blue";
  } catch {
    return "blue";
  }
};

// Substitui `Layout` + `Navbar` como elemento raiz das rotas privadas
// (src/routes/index.js). Decide sidebar (desktop/tablet) vs bottom
// navigation (mobile) usando o breakpoint `md` (900px) do tema, conforme
// Code Map da spec-fase-1-tema-shell.md.
const AppShell = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [chromeStyle, setChromeStyle] = React.useState(getStoredChromeStyle);
  const isBlue = chromeStyle === "blue";

  const handleChangeChromeStyle = (next) => {
    setChromeStyle(next);
    try {
      localStorage.setItem(CHROME_STYLE_KEY, next);
    } catch {
      // localStorage indisponível (ex.: modo privado) — preferência dura só a sessão em memória
    }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default" }}>
      {isDesktop && <Sidebar chromeStyle={chromeStyle} />}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <AppBar
          position="sticky"
          color={isBlue ? "primary" : "default"}
          elevation={0}
          sx={
            !isBlue
              ? { bgcolor: "background.paper", borderBottom: "1px solid", borderColor: "divider" }
              : undefined
          }
        >
          <Toolbar>
            {/* Nome da marca sempre visível aqui (não some quando a sidebar
                colapsa) — ver Design Notes da Fase 7. */}
            <Typography
              variant="h6"
              noWrap
              sx={{
                flexGrow: 1,
                fontFamily: "'Fraunces', serif",
                fontWeight: 700,
                fontSize: "1.35rem",
                letterSpacing: "0.3px",
              }}
            >
              Empório Machado
            </Typography>
            <LogoutMenu chromeStyle={chromeStyle} onChangeChromeStyle={handleChangeChromeStyle} />
          </Toolbar>
        </AppBar>

        <Box
          sx={{
            flexGrow: 1,
            width: "100%",
            maxWidth: "100vw",
            overflowX: "hidden",
            p: { xs: 2, md: 3 },
            pb: isDesktop ? 3 : 9,
          }}
        >
          <Outlet />
        </Box>
      </Box>

      {!isDesktop && <BottomNav />}
    </Box>
  );
};

export default AppShell;
